import { setStudentAccountDetail } from "../../store/slices/student/studentAccountDetailSlice";
import studentAccountService from "../../apiServices/student/studentAccountService";
import { setStudentTransactionInfo } from "../../store/slices/student/studentTransactions";
import { setStudentFinancialAccountDetail } from "../../store/slices/student/studentFinancialAccountDetails";

export function getStudentAccountDetail() {
    return async function (dispatch: any, getState: any) {
        let response = await studentAccountService.getAccountsDetails();
        if (response?.success === true) {
            dispatch(setStudentAccountDetail(response.data));
        } else {
            console.log("error");
        }
    };
}

export function getStudentTransactionDetail(noOfItems? : number) {
    return async function (dispatch: any, getState: any) {
        let response = await studentAccountService.getTransactionDetails(noOfItems);
        if(response?.success === true){
            dispatch(setStudentTransactionInfo(response.data));
        }
        else{
            console.log("error")
        }
    }
}

export function getStudentFinancialAcoountDetails(studentId : string){
    return async function (dispatch: any, getState: any) {
        let response = await studentAccountService.getStudentFinancialAccountDetails(studentId);
        if (response?.success === true) {
            dispatch(setStudentFinancialAccountDetail(response.data));
        }
        else{
            console.log("error");
        }
    }
}

